import type { SellerUserStateCode } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-users'

export const USER_STATE_CODES: Record<string, SellerUserStateCode> = {
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
}
